export default __webpack_public_path__ + "static/media/mq.d907441d.svg";